import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';
import type { Agent } from '../../../types/domain';

export interface ILiveChatMessage {
  readonly id: string;
  readonly type: MESSAGES.AGENT_MESSAGE;
  readonly role: ROLE.BOT;
  readonly rm: false;
  readonly avatar: boolean;
  readonly html: string;
  readonly agent: Agent;
}

export const agentReplied = (data): ILiveChatMessage => ({
  id: data.id || uuid(),
  type: MESSAGES.AGENT_MESSAGE,
  role: data.agent.id,
  rm: false,
  avatar: true,
  html: data.html,
  agent: data.agent,
});
